
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#798F8F","fill-rule":"evenodd","d":"M9.007 1C4.579 1 1 4.606 1 9.066a8.06 8.06 0 0 0 5.475 7.652c.397.08.543-.174.543-.387 0-.187-.013-.828-.013-1.496-2.227.481-2.691-.961-2.691-.961-.358-.935-.888-1.176-.888-1.176-.73-.494.053-.494.053-.494.808.054 1.233.828 1.233.828.715 1.229 1.869.882 2.333.668.066-.52.278-.881.503-1.082-1.776-.187-3.645-.881-3.645-3.98 0-.88.318-1.602.822-2.163-.08-.2-.358-1.028.08-2.136 0 0 .676-.214 2.2.828a7.7 7.7 0 0 1 2.002-.268 7.7 7.7 0 0 1 2.001.268c1.525-1.042 2.2-.828 2.2-.828.438 1.108.16 1.936.08 2.136.517.561.822 1.282.822 2.164 0 3.098-1.869 3.779-3.658 3.98.291.253.543.734.543 1.495 0 1.082-.013 1.95-.013 2.217 0 .213.146.467.543.387A8.06 8.06 0 0 0 17 9.066C17.013 4.606 13.42 1 9.007 1","clip-rule":"evenodd"}})])
          )
        }
      }
    